import { graphql } from '@apollo/client/react/hoc';
import { withRouter } from 'react-router-dom';
import articleQuery from './articleQuery.graphql';
import component from './component';

export default withRouter(graphql(articleQuery, {
  options: ({ match }) => ({ variables: { href: match.params.href } }),
  props: ({ data: { article } }) => ({ article })
})(component));
